import { UserLanguage } from '../../../../features/account/types/User'
import { LanguageMaps } from '../../../api/language'
import { CategoryNames } from '../types/Categories'

export const categoryLanguages: UserLanguage[] = ['en', 'ja', 'zh']

type LanguageEntry = Record<string, string | null | undefined>

export const languageEntry = (languageMaps: LanguageMaps | undefined, language: UserLanguage, group: string, key: number | string) =>
  (languageMaps?.[language] as Record<string, Record<string, LanguageEntry> | undefined> | undefined)?.[group]?.[String(key)]

export const readCategoryNames = (languageMaps: LanguageMaps | undefined, legacyId: number): Partial<CategoryNames> =>
  Object.fromEntries(
    categoryLanguages.flatMap((language) => {
      const name = languageEntry(languageMaps, language, 'categories', legacyId)?.name
      return typeof name === 'string' ? [[language, name]] : []
    })
  )
